import React from 'react';
import { SectionContainer, SwitcherThemedItemWithEvents } from '../../primitives';
import { type SwitcherItemType } from '../../../common/utils/links';
import {
	getItemAnalyticsContext,
	NavigationAnalyticsContext,
} from '../../../common/utils/analytics';
import messages from '../../../common/utils/messages';
import { AnalyticsItemType } from '../../../types';
import { FormattedMessage } from 'react-intl-next';
import { useExperienceSuccess, Experience } from '../../../common/utils/experience-tracker';
import { AppIcon } from '../../primitives/app-icon';
import { useIsSwitcherTeam25TestCohort } from '../experiment-provider';

export type CustomLinkSectionProps = {
	customLinks: SwitcherItemType[];
};

export const CustomLinksSection = ({ customLinks }: CustomLinkSectionProps) => {
	useExperienceSuccess(Experience.RENDER_CUSTOM_LINKS_SECTION);

	const isVisualRefreshEnabled = useIsSwitcherTeam25TestCohort();

	return (
		<SectionContainer
			sectionId="customLinks"
			title={isVisualRefreshEnabled ? undefined : <FormattedMessage {...messages.more} />}
		>
			{customLinks.map(({ analyticsAttributes, label, href, iconKey }, groupIndex) => (
				// todo: id in SwitcherItem should be consumed from custom link resolver
				<NavigationAnalyticsContext
					key={groupIndex + '.' + label}
					data={getItemAnalyticsContext(
						groupIndex,
						null,
						AnalyticsItemType.CUSTOM_LINK,
						undefined,
						analyticsAttributes,
					)}
				>
					<SwitcherThemedItemWithEvents
						tag="li"
						icon={<AppIcon iconKey={iconKey} testId="switcher-item-icon__custom" />}
						href={href}
					>
						{label}
					</SwitcherThemedItemWithEvents>
				</NavigationAnalyticsContext>
			))}
		</SectionContainer>
	);
};
